<template>
    <v-card elevation="3" min-width="540px">
        <v-card-title>
            <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                    <div class="text-black d-flex flex-column align-center">
                        <v-img :src="logo" :width="75" draggable="false"/>
                        <v-img :src="logoText" :width="100" draggable="false"/>
                    </div>
                </router-link>
            </router-link>
        </v-card-title>
        <v-card-title>Forgot your password?</v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="formData.valid" validate-on="input lazy" @submit.prevent="submit">
                <v-text-field v-model="formData.email" :rules="[vRules.required, vRules.email]" label="Email"
                              type="email"/>

                <div class="mb-3">
                    Remember your password?
                    <v-btn class="pa-0" plain size="small" variant="plain" @click="navigateTo('login')">Login</v-btn>
                </div>

                <v-btn :disabled="!formData.valid || processing" :loading="processing" block color="primary"
                       @click="submit">Request Password
                </v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script setup>
import {useNavigation} from '@/composables/globals'
import {reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {showApiError} from "@/composables/useApiError";
import {useSnackbarStore} from "@/stores/snackBarStore";
import logo from "@/assets/images/logo-1.png";
import logoText from "@/assets/images/logo-text.png";

const {navigateTo} = useNavigation()
const snackbar = useSnackbarStore()
const form = ref(null)
const processing = ref(false)
const formData = reactive({
    email: '',
    valid: false,
})


const submit = () => {
    processing.value = true;
    send('post', 'request-reset-password', formData)
        .then((response) => {
            // Persist email so Login.vue can pre-fill it after the reset completes.
            localStorage.setItem('registered_email', formData.email)
            formData.email = ''
            processing.value = false;
            snackbar.showSnackbar(response.data.message)
            // The unified response has no user.id for a non-existent email (the
            // "if this email exists" message already showed). Only advance to the
            // reset step when the server returned an id - never deref .user.id on a
            // miss, which would throw into .catch and reveal via the error toast
            // that the email is unknown (account enumeration).
            const userId = response?.data?.data?.user?.id
            if (userId) navigateTo(`reset-password`, {id: userId})
        })
        .catch(function (errorResponse) {
            processing.value = false;
            // Surface Laravel validation-error map verbatim (email format
            // is the only thing we validate here); everything else goes
            // through the throttle-aware helper so 429 shows a retry
            // window instead of the raw "Too Many Attempts" body.
            const validationErrors = errorResponse?.response?.data?.errors;
            if (validationErrors && typeof validationErrors === 'object') {
                Object.keys(validationErrors).forEach((key) => {
                    snackbar.showSnackbar(validationErrors[key][0], 'error');
                });
                return;
            }
            showApiError(snackbar, errorResponse, "Couldn't send reset email. Please try again.");
        })
}
</script>

<style scoped></style>
